import { useState } from 'react';
import geminiService from '../services/geminiService';

const GeminiTest = () => {
  const [testResult, setTestResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const runTest = async () => {
    setLoading(true);
    setTestResult(null);
    
    try {
      console.log('Testing Gemini service...');
      
      // Check if service is available
      const isAvailable = geminiService.isAvailable();
      console.log('Service available:', isAvailable);
      
      if (!isAvailable) {
        setTestResult({
          success: false,
          message: 'Service not initialized',
          details: {
            hasApiKey: !!process.env.REACT_APP_GEMINI_API_KEY,
            apiKeyLength: process.env.REACT_APP_GEMINI_API_KEY?.length,
            apiKeyStart: process.env.REACT_APP_GEMINI_API_KEY?.substring(0, 10) + '...'
          }
        });
        return;
      }
      
      // Test connection
      const result = await geminiService.testConnection();
      setTestResult(result);
      
    } catch (error) {
      console.error('Test failed:', error);
      setTestResult({
        success: false,
        message: error.message,
        error: error
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h3>Gemini AI Service Test</h3>
      
      <button onClick={runTest} disabled={loading} style={styles.button}>
        {loading ? 'Testing...' : 'Test Gemini Service'}
      </button>
      
      {testResult && (
        <div style={styles.result}>
          <h4>Test Result:</h4>
          <pre style={styles.pre}>
            {JSON.stringify(testResult, null, 2)}
          </pre>
        </div>
      )}
      
      <div style={styles.info}>
        <h4>Debug Info:</h4>
        <p>API Key Present: {process.env.REACT_APP_GEMINI_API_KEY ? 'Yes' : 'No'}</p>
        <p>API Key Length: {process.env.REACT_APP_GEMINI_API_KEY?.length || 0}</p>
        <p>Service Available: {geminiService.isAvailable() ? 'Yes' : 'No'}</p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '2rem',
    maxWidth: '600px',
    margin: '0 auto',
    background: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  button: {
    padding: '0.75rem 1.5rem',
    background: '#4285f4',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '1rem',
    marginBottom: '1rem',
  },
  result: {
    marginTop: '1rem',
    padding: '1rem',
    background: '#f5f5f5',
    borderRadius: '6px',
  },
  pre: {
    background: '#fff',
    padding: '1rem',
    borderRadius: '4px',
    overflow: 'auto',
    fontSize: '0.9rem',
  },
  info: {
    marginTop: '1rem',
    padding: '1rem',
    background: '#e3f2fd',
    borderRadius: '6px',
  }
};

export default GeminiTest;